export default __webpack_public_path__ + "static/media/bg-dashboard-1.3367e2d9.png";